import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  header: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    borderTopWidth: "x178xt8z",
    borderTopStyle: "x13fuv20",
    borderTopColor: "xqu00je",
    paddingTop: "x12t3zde",
    marginTop: "x1c4vshn",
    marginBottom: "xhbfen4",
    $$css: true
  },
  headerIcon: {
    color: "x1gonuu0",
    $$css: true
  },
  headerTitle: {
    fontSize: "x1lkfr7t",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    $$css: true
  },
  searching: {
    color: "xarw3lm",
    marginBottom: "xhbfen4",
    $$css: true
  },
  list: {
    listStyle: "xe8uvvx",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "xrvj5dj",
    gridTemplateColumns: "x1y6fwsi xs2b3ki",
    columnGap: "xgvynzx",
    $$css: true
  },
  card: {
    display: "x78zum5",
    alignItems: "x1cy8zhl",
    gap: "x1fsutb",
    rowGap: null,
    columnGap: null,
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "xbuxeer",
    $$css: true
  },
  info: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    minWidth: "xeuugli",
    paddingTop: "x1iul6r4",
    $$css: true
  },
  nameRow: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  verified: {
    color: "x1bj2zf7",
    flexShrink: "x2lah0s",
    $$css: true
  },
  name: {
    fontSize: "x1jchvi3",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    $$css: true
  },
  chips: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    marginTop: "x72edsj",
    $$css: true
  },
  chip: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x1bilvtl",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x1ryrjj2",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    $$css: true
  },
  personalityChip: {
    backgroundColor: "xdzv16h",
    color: "xtt1gjl",
    $$css: true
  },
  personalityIcon: {
    color: "x1yam35l",
    $$css: true
  },
  interestChip: {
    backgroundColor: "x1gvq2gg",
    color: "xarw3lm",
    $$css: true
  }
};